import { Row, Col } from "react-grid-system";
import { Input, Modal, Select } from "antd";
import { useState } from "react";
import { useDiscounts } from "../../data/Discounts";


export default function AddPartnerModal({ isOpen, onOk, onCancel }: {
    isOpen: boolean,
    onOk: (name: string, surName: string, email: string, discount: number, wsdcId: string | null, discountCode: string | null) => void,
    onCancel: () => void
}) {
    const [name, setName] = useState<string>("");
    const [surName, setSurName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [discount, setDiscount] = useState<number>(0);
    const [wsdcId, setWsdcId] = useState<string | null>(null);
    const [discountCode, setDiscountCode] = useState<string | null>(null);
    const discounts = useDiscounts(state => state.discounts);

    return (
        <Modal
            open={isOpen}
            destroyOnClose
            closable
            title={`Add partner`}
            cancelText={"Cancel"}
            okText={"Add"}
            okButtonProps={{ disabled: name === "" || surName === "" || email === "" || ((discount === 3 || discount === 4) && (wsdcId === null || wsdcId === "")) }}
            onOk={() => onOk(name, surName, email, discount === 1337 ? 0 : discount, wsdcId, discountCode)}
            onCancel={() => onCancel()}>
            <p>Please add a partner. Afterwards, you can choose him or her for all other passes.</p>
            <Row gutterWidth={16}>
                <Col sm={6}>
                    <p style={{ marginBottom: "2px" }}><b>First Name:</b></p>
                    <Input value={name} onChange={e => setName(e.target.value)}></Input>
                </Col>
                <Col sm={6}>
                    <p style={{ marginBottom: "2px" }}><b>Last Name:</b></p>
                    <Input value={surName} onChange={e => setSurName(e.target.value)}></Input>
                </Col>
                <Col sm={6}>
                    <p style={{ marginBottom: "2px" }}><b>E-Mail:</b></p>
                    <Input value={email} onChange={e => setEmail(e.target.value)}></Input>
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <p style={{ marginBottom: "2px" }}><b>Discount:</b></p>
                    <Select disabled={discountCode != null && discountCode !== ""} onChange={(val) => setDiscount(val)} value={discount} style={{ width: "100%", textAlign: "left" }}>
                        <Select.Option value={0} >None</Select.Option>
                        {discounts.map(discount => (
                            <Select.Option key={discount.id} value={discount.id}>{discount.name}</Select.Option>
                        ))}
                        <Select.Option value={1337}>Code</Select.Option>
                    </Select>
                </Col>
                <Col sm={6} style={{ display: discount === 1337 ? "block" : "none" }} >
                    <p style={{ marginBottom: "2px" }}><b>Code:</b></p>
                    <Input disabled={discount !== 0 && discount !== 1337} value={discountCode ?? ""} onChange={e => setDiscountCode(e.target.value)}></Input>
                </Col>
                <Col sm={12}>
                    <p style={{ marginBottom: "2px" }}><b>WSDC-ID:</b></p>
                    <Input value={wsdcId ?? ""} onChange={e => setWsdcId(e.target.value)}></Input>
                </Col>
            </Row>
        </Modal>
    )
}
